import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Action, Store } from "@ngrx/store";
import { CountryService } from "@services/country.service";
import { catchError, mergeMap, Observable, of, switchMap } from "rxjs";

import {
  COUNTRY_ACTION_FAILURE,
  LOAD_COUNTRIES,
  SET_COUNTRIES,
  SET_COUNTRIES_LOADING,
} from "./country.actions";

@Injectable()
export class CountryEffects {
  loadCountries$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(LOAD_COUNTRIES),
      mergeMap((): Observable<Action> => {
        this.store.dispatch(SET_COUNTRIES_LOADING({ loading: true }));

        return this.countryService.getCountries$().pipe(
          switchMap((data) => {
            this.store.dispatch(SET_COUNTRIES_LOADING({ loading: false }));

            return of(SET_COUNTRIES({ data }));
          }),
          catchError((error: HttpErrorResponse) => {
            this.store.dispatch(SET_COUNTRIES_LOADING({ loading: false }));
            return of(COUNTRY_ACTION_FAILURE({ error }));
          })
        );
      })
    );
  });

  constructor(
    private actions$: Actions,
    private countryService: CountryService,
    private store: Store
  ) {}
}
